<template>
  <div class="page-report">
    <div class="row mb-2 pe-4">
      <div class="col-lg-12 col-md-12 col-12 d-flex align-items-center">
        <div class="color-common">
          <h3 class="title-page mb-0 ps-3">INVENTORY</h3>
        </div>
      </div>
    </div>
    <div class="page-header align-items-start min-vh-100 inventory-page">
      <span class="mask bg-white"></span>
      <div class="container">
        <div class="row">
          <div class="col-lg-12 col-md-12 col-12 mx-auto mt-4">
            <div class="d-flex align-items-center">
              <h2 class="me-3">Overview</h2>
              <div class="d-flex align-items-center">
                <material-input
                  hidden
                  type="file"
                  id="file_import"
                  name="file_import"
                  @change="onFileChangeItems($event)"
                  accept=".xlsx"
                />
                <material-button
                  @click="openAddItemModal()"
                  class="btn btn-sm btn-background mw-185px me-3"
                >
                  Add Item
                </material-button>
                <material-button
                  @click="chooseFile()"
                  class="btn btn-sm btn-background mw-185px me-3"
                >
                  Import
                </material-button>
                <div class="sample-file" @click="downloadSampleFile()">
                  sample.xlsx
                </div>
              </div>
            </div>
            <FormSearch
              :openAddItemModal="openAddItemModal"
              @export="exportFile"
              @reset-filters="handleResetFilters"
              :get-list="getList"
              :total="total"
              :total_low_on_stock="total_low_on_stock"
              :total_exceeded_high_stock="total_exceeded_high_stock"
              :total_hidden_item="total_hidden_item"
              :columns="columns"
              :columnChecked="columnChecked"
              :changeCheckbox="changeCheckbox"
            />
            <div
              class="row mt-7"
              style="min-height: 1120px"
              v-if="isLoadDone"
              v-show="isLoadDoneDataTable"
            >
              <div class="col-12">
                <div class="col-12 mb-1">
                  <div class="search-container">
                    <input
                      class="nosubmit"
                      type="search"
                      id="keyword"
                      v-model="keyword"
                      extraClass
                      name="keyword"
                      placeholder="Search"
                      @keyup.enter="searchKeyword"
                    />
                    <button
                      class="btn btn-primary search-btn"
                      type="button"
                      @click="searchKeyword"
                    >
                      Search
                    </button>
                  </div>
                </div>
                <div>
                  <div class="px-0 pb-2" style="overflow: visible;">
                    <div class="p-0 custom-table" style="overflow: visible;">
                      <table
                        class="table align-items-center mb-0 dataTable"
                        ref="dataTable"
                        style="overflow: visible; border: 1px solid #d2d6da;"
                      >
                        <thead>
                          <tr>
                            <th class="text-left font-weight-bolder"></th>
                            <template
                              v-for="(item, index) in headersData"
                              :key="index"
                            >
                            <th
                              class="text-left font-weight-bolder position-relative"
                            >
                              <div class="d-flex align-items-center position-relative" style="padding-right: 40px;">
                                <div
                                  class="pt-3 flex-grow-1"
                                  style="position: unset"
                                  :class="[
                                    !!item.hasSortBy
                                      ? 'wrapper-sortby pointer'
                                      : '',
                                    ESortDirectionSelect.idx == index + 1
                                      ? ESortDirectionSelect.direction ===
                                        ESortDirection.Desc
                                        ? 'sort-desc'
                                        : 'sort-asc'
                                      : '',
                                  ]"
                                  @click="
                                    handleChangeSortColumn(
                                      index + 1,
                                      item.field
                                    )
                                  "
                                >
                                  {{ item.label }}
                                </div>
                                <div class="dropdown" style="position: absolute; right: 15px; top: 50%; transform: translateY(-50%); z-index: 10;">
                                  <i
                                    class="material-icons filter-icon"
                                    :id="`filterDropdown-${index + 1}`"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                    :style="{
                                      cursor: 'pointer',
                                      fontSize: '18px',
                                      color: isColumnFiltered('field', item.field, null) ? '#007bff' : '#BABBBD'
                                    }"
                                  >
                                    filter_list
                                  </i>
                                  <ul
                                    class="dropdown-menu px-2"
                                    :aria-labelledby="`filterDropdown-${index + 1}`"
                                  >
                                    <div class="dropdown-header">Filter by {{ item.label }}</div>
                                    <li class="mb-1">
                                      <select
                                        :value="getFilterOperator(`field_${item.field}`)"
                                        @input="setFilterOperator(`field_${item.field}`, $event.target.value)"
                                        class="form-select"
                                        style="padding: 5px; border: 1px solid #ced4da;"
                                      >
                                        <option value="" disabled>--- Select Operator ---</option>
                                        <option value="equal">Is equal to</option>
                                        <option value="less_than">Is less than</option>
                                        <option value="greater_than">Is greater than</option>
                                        <option value="contains">Contains</option>
                                      </select>
                                    </li>
                                    <li class="my-2">
                                      <input
                                        :value="getFilterValue(`field_${item.field}`)"
                                        @input="setFilterValue(`field_${item.field}`, $event.target.value)"
                                        type="text"
                                        class="w-100 p-1"
                                        placeholder="Enter value"
                                        style="border-radius: 0.375rem; border: 1px solid #ced4da; outline: none;"
                                      >
                                    </li>
                                    <li class="d-flex justify-content-center mt-3">
                                      <button
                                        class="btn btn-primary mx-auto"
                                        style="margin-bottom: 0.5rem;"
                                        @click="applyColumnFilter('field', item.field, null)"
                                      >
                                        Apply
                                      </button>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </th>
                            </template>
                            <th
                              class="text-left font-weight-bolder position-relative"
                              v-for="branch in physicalBranchesArray"
                              :key="headersData.length + branch.id"
                            >
                              <div class="d-flex align-items-center position-relative" style="padding-right: 40px;">
                                <div
                                  class="pt-3 flex-grow-1"
                                  style="position: unset"
                                  :class="[
                                    'wrapper-sortby pointer',
                                    ESortDirectionSelect.idx ==
                                    headersData.length + branch.index + 1
                                      ? ESortDirectionSelect.direction ===
                                        ESortDirection.Desc
                                        ? 'sort-desc'
                                        : 'sort-asc'
                                      : '',
                                  ]"
                                  @click="
                                    handleChangeSortColumn(
                                      headersData.length + branch.index + 1,
                                      'physical_branch',
                                      branch.index
                                    )
                                  "
                                >
                                  {{ branch.name }}
                                </div>
                                <div class="dropdown" style="position: absolute; right: 15px; top: 50%; transform: translateY(-50%); z-index: 10;">
                                  <i
                                    class="material-icons filter-icon"
                                    :id="`filterDropdown-physical-${branch.id}`"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                    :style="{
                                      cursor: 'pointer',
                                      fontSize: '18px',
                                      color: isColumnFiltered('physical_branch', null, branch.id) ? '#007bff' : '#BABBBD'
                                    }"
                                  >
                                    filter_list
                                  </i>
                                  <ul
                                    class="dropdown-menu px-2"
                                    :aria-labelledby="`filterDropdown-physical-${branch.id}`"
                                  >
                                    <div class="dropdown-header">Filter by Stock Qty</div>
                                    <li class="mb-1">
                                      <select
                                        :value="getFilterOperator(`physical_${branch.id}`)"
                                        @input="setFilterOperator(`physical_${branch.id}`, $event.target.value)"
                                        class="form-select"
                                        style="padding: 5px; border: 1px solid #ced4da;"
                                      >
                                        <option value="" disabled>--- Select Operator ---</option>
                                        <option value="equal">Is equal to</option>
                                        <option value="less_than">Is less than</option>
                                        <option value="greater_than">Is greater than</option>
                                        <option value="contains">Contains</option>
                                      </select>
                                    </li>
                                    <li class="my-2">
                                      <input
                                        :value="getFilterValue(`physical_${branch.id}`)"
                                        @input="setFilterValue(`physical_${branch.id}`, $event.target.value)"
                                        type="number"
                                        class="w-100 p-1"
                                        placeholder="Enter value"
                                        style="border-radius: 0.375rem; border: 1px solid #ced4da; outline: none;"
                                      >
                                    </li>
                                    <li class="d-flex justify-content-center mt-3">
                                      <button
                                        class="btn btn-primary mx-auto"
                                        style="margin-bottom: 0.5rem;"
                                        @click="applyColumnFilter('physical_branch', null, branch.id)"
                                      >
                                        Apply
                                      </button>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </th>
                          </tr>
                        </thead>
                        <tbody style="height: 180px;">
                          <tr v-for="(value, key) in items" :key="key">
                            <td class="text-center text-xss w-5">
                              <div
                                class="d-flex align-items-center justify-content-center"
                              >
                                <i
                                  class="fa fa-ellipsis-v text-secondary cursor-pointer dropdownMenuButton"
                                  aria-hidden="true"
                                  id="dropdownMenuButton"
                                  data-bs-toggle="dropdown"
                                  style="font-size: 16px"
                                ></i>
                                <ul
                                  class="dropdown-menu"
                                  aria-labelledby="dropdownMenuButton"
                                >
                                  <li>
                                    <a
                                      class="dropdown-item"
                                      href="#"
                                      @click="openAddItemModal()"
                                    >
                                      <i class="material-icons me-1">add</i>
                                      <span>Add</span>
                                    </a>
                                  </li>
                                  <li>
                                    <a
                                      class="dropdown-item"
                                      href="#"
                                      @click="editItem(value)"
                                    >
                                      <i class="material-icons me-1">edit</i>
                                      <span>Edit</span>
                                    </a>
                                  </li>
                                  <li>
                                    <a
                                      class="dropdown-item"
                                      href="#"
                                      @click="openStockMovementModal(value)"
                                    >
                                      <i class="material-icons me-1"
                                        >trending_flat</i
                                      >
                                      <span>Stock Movement</span>
                                    </a>
                                  </li>
                                  <li>
                                    <a
                                      class="dropdown-item"
                                      href="#"
                                      @click="openInventoryPropertiesModal(value)"
                                    >
                                      <i class="material-icons me-1"
                                        >post_add</i
                                      >
                                      <span>Inventory Setting</span>
                                    </a>
                                  </li>
                                  <li>
                                    <a
                                      class="dropdown-item"
                                      href="#"
                                      @click="showHideItem(value)"
                                    >
                                      <i class="material-icons me-1"
                                        >{{ value?.inventory_status ? 'visibility_off' : 'visibility' }}</i
                                      >
                                      <span>{{ value?.inventory_status ? 'Hide' : 'Show' }}</span>
                                    </a>
                                  </li>
                                </ul>
                              </div>
                            </td>
                            <td
                              class="text-left text-xss font-weight-bold w-10"
                            >
                              {{ value?.item_no }}
                            </td>
                            <td class="text-left text-xss w-10">
                              {{ value?.barcode }}
                            </td>
                            <td class="text-left text-xss w-30">
                              {{ value?.item_name }}
                            </td>
                            <td
                              class="text-left text-xss"
                              v-if="columnShowed.includes('description')"
                            >
                              {{ value?.description }}
                            </td>
                            <td class="text-right text-xss">
                              {{ formatPrice(value?.unit_cost) }}
                            </td>
                            <td class="text-left text-xss">
                              {{ value?.uom }}
                            </td>
                            <td
                              class="text-left text-xss"
                              v-if="columnShowed.includes('type_name')"
                            >
                              {{ value?.type_name }}
                            </td>
                            <td
                              class="text-left text-xss"
                              v-if="columnShowed.includes('group_name')"
                            >
                              {{ value?.group_name }}
                            </td>
                            <td
                              class="text-right text-xss"
                              v-for="(
                                physicalBranch, index
                              ) in value.inventory_item_stock_by_physical_branch"
                              :key="index"
                            >
                              <span
                                :style="{ color: physicalBranch?.status_color }"
                                >{{ physicalBranch?.stock_balance }}</span
                              >
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div class="d-flex justify-content-between align-items-center mb-3 px-3 pt-3">
                    <div class="rows-per-page">
                      <span class="rows-per-page__label">Rows per page</span>
                      <div class="rows-per-page__control">
                        <select v-model="limit" @change="setLimitPerPage" class="rows-per-page__select">
                          <option :value="20">20</option>
                          <option :value="30">30</option>
                          <option :value="40">40</option>
                          <option :value="50">50</option>
                        </select>
                      </div>
                    </div>
                    <pagination
                      v-if="pagination.last_page > 1"
                      :pagination="pagination"
                      :current_page="pagination.current_page"
                      :last_page="pagination.last_page"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="position-fixed top-1 end-1 z-index-2 message-success">
        <material-snackbar
          v-if="snackbar === 'danger' || snackbar === 'success'"
          title=""
          date=""
          :description="message"
          :icon="{ component: 'campaign', color: 'white' }"
          :color="snackbar"
          :close-handler="closeSnackbar"
        />
      </div>
      <material-loading :active="loaderActive" />
      <AddItemModal
        :keyReload="keyReloadAddItem"
        :isEditItem="isEditItem"
        :isInventoryItem="true"
        @reload-list-category="getList(page, type)"
      ></AddItemModal>
      <ModalStockMovement
        :keyReload="keyReloadStockMovement"
        :itemId="isEditItem"
        :itemSelect="itemSelect"
      ></ModalStockMovement>
      <ModalInventoryProperties
        :keyReload="keyReloadInventoryProperties"
        :itemId="isEditItem"
        :itemSelect="itemSelect"
        @reload-list="getList(page, type)"
      ></ModalInventoryProperties>
      <ModalError :message="importErrMessage" />
    </div>
    <form
      :action="`${actionDownload}/merchant/inventory/download-sample-file/item`"
      method="POST"
    >
      <input type="hidden" name="merchantId" :value="merchantIdExport" />
      <input type="hidden" name="merchant_code" :value="merchantCode" />
      <input type="hidden" name="token" :value="token" />
      <input id="downloadSampleFile" type="submit" class="d-none" />
    </form>
    <form
      :action="`${actionDownload}/merchant/inventory/items/export`"
      method="POST"
    >
      <input type="hidden" name="merchantId" :value="merchantIdExport" />
      <input type="hidden" name="merchant_code" :value="merchantCode" />
      <input type="hidden" name="list_field_show" :value="columnShowed" />
      <input type="hidden" name="type" :value="type" />
      <input type="hidden" name="token" :value="token" />
      <input type="hidden" name="action_export" :value="action_export" />
      <input type="hidden" name="action" value="export" />
      <input id="downloadFormOverview" type="submit" class="d-none" />
    </form>
  </div>
</template>

<script>
import MaterialSnackbar from "@/components/MaterialSnackbar.vue";
import "bootstrap/dist/js/bootstrap.bundle";
import MaterialLoading from "@/components/MaterialLoading.vue";
import "bootstrap/js/dist/modal";
import "@vuepic/vue-datepicker/dist/main.css";
import "@vuepic/vue-datepicker/dist/main.css";
import moment from "moment";
import InventoryService from "../../services/inventory.service";
import CommonFunctionService from "../../services/commonFunction.service";
import { startOfMonth } from "date-fns";
import $ from "jquery";
import TokenService from "../../services/token.service";
import FormSearch from "./components/FormSearch.vue";
import "datatables.net";
import Pagination from "@/components/Pagination.vue";
import AddItemModal from "@/components/AddItem.vue";
import { GET_ALL } from "./mock_data";
import ModalStockMovement from "./components/ModalStockMovement.vue";
import MaterialButton from "@/components/MaterialButton.vue";
import MaterialInput from "@/components/MaterialInput.vue";
import ModalError from "./components/ModalError.vue";
import ModalInventoryProperties from "./components/ModalInventoryProperties.vue";

export default {
  name: "inventory-overview",
  components: {
    MaterialSnackbar,
    MaterialLoading,
    FormSearch,
    Pagination,
    AddItemModal,
    ModalStockMovement,
    MaterialButton,
    MaterialInput,
    ModalError,
    ModalInventoryProperties,
  },
  data() {
    return {
      isLoadDone: false,
      isLoadDoneDataTable: false,
      token: TokenService.getLocalAccessToken(),
      actionDownload: process.env.VUE_APP_BASE_URL,
      merchantIdExport: localStorage.getItem("MERCHANT_ID", ""),
      merchantCode: localStorage.getItem("MERCHANT_CODE", ""),
      message: "",
      snackbar: null,
      loaderActive: false,
      items: null,
      form: {
        physical_branch_id: -1,
        branch_id: -1,
        from_date: moment(startOfMonth(new Date())),
        to_date: new Date(),
      },
      ESortDirectionSelect: {
        idx: null,
        field: "",
        direction: null,
      },
      ESortDirection: {
        Asc: "asc",
        Desc: "desc",
      },
      action_export: "csv",
      from_date_export: "",
      to_date_export: "",
      dataTable: null,
      columnSearch: [],
      pagination: {},
      page: 1,
      keyReloadAddItem: "keyReloadAddItem",
      isEditItem: 0,
      itemSelect: null,
      type: GET_ALL,
      total: 0,
      total_low_on_stock: 0,
      total_exceeded_high_stock: 0,
      total_hidden_item: 0,
      columns: [
        { value: "all", label: "All" },
        { value: "description", label: "Description" },
        { value: "type_name", label: "Type" },
        { value: "group_name", label: "Group" },
      ],
      columnShowed: [],
      columnChecked: [],
      physicalBranches: [],
      keyReloadStockMovement: "keyReloadStockMovement",
      keyReloadInventoryProperties: "keyReloadInventoryProperties",
      fileImport: null,
      importErrMessage: "",
      stockBalanceFilter: null,
      columnFilters: {},
      activeColumnFilter: null,
      limit: 20,
      keyword: "",
    };
  },
  computed: {
    headersData() {
      let headers = [
        {
          label: "Item no",
          field: "item_no",
          hasSortBy: true,
        },
        {
          label: "Barcode",
          field: "barcode",
          hasSortBy: true,
        },
        {
          label: "Item name",
          field: "item_name",
          hasSortBy: true,
        },
        {
          label: "Unit Cost",
          field: "unit_cost",
          hasSortBy: true,
        },
        {
          label: "UOM",
          field: "uom",
          hasSortBy: true,
        },
      ];

      if (this.columnShowed.includes("description")) {
        headers.splice(3, 0, {
          field: "description",
          label: "Description",
          hasSortBy: false,
        });
      }

      if (this.columnShowed.includes("type_name")) {
        headers.push({ field: "type_name", label: "Type", hasSortBy: false });
      }

      if (this.columnShowed.includes("group_name")) {
        headers.push({ field: "group_name", label: "Group", hasSortBy: false });
      }

      return headers;
    },
    physicalBranchesArray() {
      // physicalBranches is already an array [{id, name}], just add index
      return this.physicalBranches.map((branch, index) => ({
        id: branch.id,
        name: branch.name,
        index: index,
      }));
    },
  },
  methods: {
    format(date) {
      return CommonFunctionService.formatDateShow(date);
    },

    formatPrice(price) {
      price = parseFloat(price).toFixed(2);
      return "$ " + price.toLocaleString("en-US", { minimumFractionDigits: 2 });
    },

    exportFile(type = "csv") {
      this.action_export = type;
      this.from_date_export = this.dateFormat(this.form.from_date);
      this.to_date_export = this.dateFormat(this.form.to_date);
      setTimeout(() => {
        $("#downloadFormOverview").click();
      }, 150);
    },

    chooseFile() {
      $("#file_import").click();
    },

    onFileChangeItems(e) {
      this.fileImport = null;
      let files = e.target.files || e.dataTransfer.files;

      if (!files.length) {
        return;
      }

      let file = files[0];

      if (file != null || file != undefined) {
        if (
          ![
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            "application/vnd.ms-excel",
          ].includes(file.type)
        ) {
          alert("File must be an xlsx or xls.");
        } else {
          this.fileImport = file;

          setTimeout(() => {
            this.importItems();
          }, 100);
        }
      }

      $("#file_import")[0].value = "";
    },

    downloadSampleFile() {
      $("#downloadSampleFile").click();
    },

    importItems() {
      this.showLoader();
      this.importErrMessage = "";
      if (!this.fileImport) {
        alert("Please select file to import.");
        return;
      }

      var dataForm = {
        file_import: this.fileImport,
      };

      InventoryService.importItems(dataForm).then(
        (response) => {
          if (response.data.result.isSuccess) {
            const data = response.data.data;

            if (data.status) {
              this.snackbar = "success";
              this.message = "Imported successful";
              this.setTimeOutNotification();

              this.getList(this.page, this.type);
            } else {
              this.importErrMessage = data.error_message;
              $(".btn-error-modal").click();
            }
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
            this.setTimeOutNotification();
          }
          this.hideLoader();
        },
        (error) => {
          this.snackbar = "danger";
          this.message = error.response.data.result.message;
          this.hideLoader();
          this.setTimeOutNotification();
        }
      );
    },

    dateFormat(date) {
      if (date == null) {
        return null;
      } else {
        return moment(date).format("YYYY-MM-DD");
      }
    },

    closeSnackbar() {
      this.snackbar = null;
    },

    setTimeOutNotification() {
      setTimeout(() => {
        this.snackbar = null;
      }, 3000);
    },

    initializeDataTable() {
      if (this.dataTable) {
        this.dataTable.destroy();
        this.dataTable = null;
      }

      this.dataTable = $(this.$refs.dataTable).DataTable({
        paging: false,
        searching: true,
        ordering: false,
        info: false,
      });
    },

    searchColumn(index) {
      this.dataTable.column(index).search(this.columnSearch[index]).draw();
    },

    handleChangeSortColumn(idx, field, physical_branch_idx = 0) {
      if (
        this.ESortDirectionSelect.idx &&
        this.ESortDirectionSelect.idx == idx
      ) {
        this.ESortDirectionSelect.direction =
          this.ESortDirectionSelect.direction === this.ESortDirection.Asc
            ? this.ESortDirection.Desc
            : this.ESortDirection.Asc;
      } else {
        this.ESortDirectionSelect = {
          idx: idx,
          field: field,
          direction: this.ESortDirection.Asc,
        };
      }

      const direction = this.ESortDirectionSelect.direction;

      this.items.sort(function (item, item2) {
        if (field == "physical_branch") {
          if (direction == "asc") {
            if (
              item.inventory_item_stock_by_physical_branch[
                physical_branch_idx
              ]?.stock_balance.toString() >
              item2.inventory_item_stock_by_physical_branch[
                physical_branch_idx
              ]?.stock_balance.toString()
            )
              return 1;
            if (
              item.inventory_item_stock_by_physical_branch[
                physical_branch_idx
              ]?.stock_balance.toString() <
              item2.inventory_item_stock_by_physical_branch[
                physical_branch_idx
              ]?.stock_balance.toString()
            )
              return -1;
          }

          if (direction == "desc") {
            if (
              item.inventory_item_stock_by_physical_branch[
                physical_branch_idx
              ]?.stock_balance.toString() <
              item2.inventory_item_stock_by_physical_branch[
                physical_branch_idx
              ]?.stock_balance.toString()
            )
              return 1;
            if (
              item.inventory_item_stock_by_physical_branch[
                physical_branch_idx
              ]?.stock_balance.toString() >
              item2.inventory_item_stock_by_physical_branch[
                physical_branch_idx
              ]?.stock_balance.toString()
            )
              return -1;
          }

          return 0;
        } else {
          if (direction == "asc") {
            if (item[field] > item2[field]) return 1;
            if (item[field] < item2[field]) return -1;
          }

          if (direction == "desc") {
            if (item[field] < item2[field]) return 1;
            if (item[field] > item2[field]) return -1;
          }

          return 0;
        }
      });
    },

    editItem(item) {
      this.isEditItem = item.id;
      this.itemSelect = item;
      this.keyReloadAddItem = Math.random().toString();
      $("#show-modal-add-item").click();
    },

    openStockMovementModal(item) {
      this.isEditItem = item.id;
      this.itemSelect = item;
      this.keyReloadStockMovement = Math.random().toString();
      $(".btn-show-stock-movement-modal").click();
    },

    openInventoryPropertiesModal(item) {
      this.isEditItem = item.id;
      this.itemSelect = item;
      this.keyReloadInventoryProperties = Math.random().toString();
      $(".btn-show-inventory-properties-modal").click();
    },

    showHideItem(item) {
      this.showLoader();
      InventoryService.showHideItem(item.id).then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.snackbar = "success";
            this.message = "Hide item successful";
            this.setTimeOutNotification();

            this.getList(this.page);
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
            this.setTimeOutNotification();
          }
          this.hideLoader();
        },
        (error) => {
          this.snackbar = "danger";
          this.message = error.response.data.result.message;
          this.hideLoader();
          this.setTimeOutNotification();
        }
      );
    },

    getList(page, type = null) {
      // Only update type if explicitly provided, otherwise keep current type
      if (type !== null) {
        this.type = type;
      }
      // Use current type if not provided, default to GET_ALL if not set
      const currentType = type !== null ? type : (this.type || GET_ALL);

      this.isLoadDone = false;
      this.isLoadDoneDataTable = false;
      this.showLoader();
      var dataForm = {
        page: page,
        type: currentType,
        limit: this.limit,
      };

      if (this.keyword !== "") {
        dataForm.keyword = this.keyword;
      }

      // Add stock balance filter if exists
      if (this.stockBalanceFilter) {
        dataForm.physical_branch_id = this.stockBalanceFilter.physical_branch_id;
        dataForm.stock_balance_operator = this.stockBalanceFilter.stock_balance_operator;
        dataForm.stock_balance_value = this.stockBalanceFilter.stock_balance_value;
      }

      // Add column filters - only one filter at a time
      if (this.activeColumnFilter && this.activeColumnFilter.operator && this.activeColumnFilter.value) {
        if (this.activeColumnFilter.type === 'physical_branch') {
          dataForm.filters = {
            physical_branch_id: this.activeColumnFilter.branchId,
            operator: this.activeColumnFilter.operator,
            value: this.activeColumnFilter.value,
          };
        } else {
          dataForm.filters = {
            field: this.activeColumnFilter.field,
            operator: this.activeColumnFilter.operator,
            value: this.activeColumnFilter.value,
          };
        }
      }

      InventoryService.getItems(dataForm).then(
        (response) => {
          if (response.data.result.isSuccess) {
            const data = response.data.data;
            this.items = data.data.items;
            this.pagination = data.data;
            this.page = this.pagination.current_page;
            this.total = data.total;
            this.total_low_on_stock = data.total_low_on_stock;
            this.total_exceeded_high_stock = data.total_exceeded_high_stock;
            this.total_hidden_item = data.total_hidden_item;
            this.physicalBranches = data.physical_branches;

            this.checkColumnSearch();

            this.isLoadDone = true;
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
            this.setTimeOutNotification();
          }
          this.hideLoader();
        },
        (error) => {
          this.snackbar = "danger";
          this.message = error;
          this.hideLoader();
          this.setTimeOutNotification();
        }
      );
    },

    checkColumnSearch() {
      const totalColumn =
        this.headersData.length + this.physicalBranches.length;
      this.columnSearch = [""];

      for (let i = 0; i < totalColumn; i++) {
        this.columnSearch.push("");
      }
    },

    handleApplyFilter(filterData) {
      this.stockBalanceFilter = filterData;
      this.getList(this.page, this.type);
    },

    handleResetFilters() {
      // Clear all filters
      this.stockBalanceFilter = null;
      this.activeColumnFilter = null;
      this.columnFilters = {};

      // Clear DataTable column search if DataTable is initialized
      if (this.dataTable) {
        const totalColumn = this.headersData.length + this.physicalBranches.length;
        for (let i = 1; i <= totalColumn; i++) {
          this.dataTable.column(i).search("").draw();
        }
      }

      // Clear column search inputs
      this.columnSearch = [];

      // Reset to page 1 and call getList without pushing params to URL
      this.page = 1;
      this.getList(1, this.type);
    },

    getFilterOperator(key) {
      if (!this.columnFilters[key]) {
        this.columnFilters[key] = { operator: '', value: '' };
      }
      return this.columnFilters[key].operator || '';
    },

    setFilterOperator(key, value) {
      if (!this.columnFilters[key]) {
        this.columnFilters[key] = { operator: '', value: '' };
      }
      this.columnFilters[key].operator = value;
    },

    getFilterValue(key) {
      if (!this.columnFilters[key]) {
        this.columnFilters[key] = { operator: '', value: '' };
      }
      return this.columnFilters[key].value || '';
    },

    isColumnFiltered(type, field, branchId) {
      if (!this.activeColumnFilter) {
        return false;
      }

      if (type === 'physical_branch') {
        return (
          this.activeColumnFilter.type === 'physical_branch' &&
          this.activeColumnFilter.branchId === branchId &&
          this.activeColumnFilter.operator &&
          this.activeColumnFilter.value
        );
      } else {
        return (
          this.activeColumnFilter.type === 'field' &&
          this.activeColumnFilter.field === field &&
          this.activeColumnFilter.operator &&
          this.activeColumnFilter.value
        );
      }
    },

    setFilterValue(key, value) {
      if (!this.columnFilters[key]) {
        this.columnFilters[key] = { operator: '', value: '' };
      }
      this.columnFilters[key].value = value;
    },

    applyColumnFilter(type, field, branchId) {
      let filterKey;
      if (type === 'physical_branch') {
        filterKey = `physical_${branchId}`;
      } else {
        filterKey = `field_${field}`;
      }

      const filter = this.columnFilters[filterKey];
      if (!filter || !filter.operator || !filter.value) {
        return;
      }

      // Store the filter with type and field/branchId info
      this.columnFilters[filterKey].type = type;
      this.columnFilters[filterKey].field = field;
      this.columnFilters[filterKey].branchId = branchId;

      // Store active filter
      this.activeColumnFilter = {
        type: type,
        field: field,
        branchId: branchId,
        operator: filter.operator,
        value: filter.value,
      };

      // Close dropdown by removing show class
      this.$nextTick(() => {
        const $ = window.$;
        if ($) {
          if (type === 'physical_branch') {
            $(`#filterDropdown-physical-${branchId}`).parent().removeClass('show');
            $(`.dropdown-menu[aria-labelledby="filterDropdown-physical-${branchId}"]`).removeClass('show');
            $(`#filterDropdown-physical-${branchId}`).attr('aria-expanded', 'false');
          } else {
            const headerIndex = this.headersData.findIndex(h => h.field === field);
            if (headerIndex !== -1) {
              $(`#filterDropdown-${headerIndex + 1}`).parent().removeClass('show');
              $(`.dropdown-menu[aria-labelledby="filterDropdown-${headerIndex + 1}"]`).removeClass('show');
              $(`#filterDropdown-${headerIndex + 1}`).attr('aria-expanded', 'false');
            }
          }
        }
      });

      // Call API with filters
      this.getList(this.page, this.type);
    },

    // getList(page, isSort = false) {
    //   if (!isSort) {
    //     this.isLoadDone = false;
    //     this.isLoadDoneDataTable = false;
    //   }

    //   this.showLoader();
    //   var dataForm = {
    //     physical_branch_id: this.form.physical_branch_id,
    //     // branch_id: this.form.branch_id,
    //     from_date: this.dateFormat(this.form.from_date),
    //     to_date: this.dateFormat(this.form.to_date),
    //     page: page,
    //     sortCol: this.ESortDirectionSelect.idx,
    //     sortType: this.ESortDirectionSelect.direction,
    //   };

    //   AnalyticsService.itemSalesSummaryReport(dataForm).then(
    //     (response) => {
    //       if (response.data.result.isSuccess) {
    //         const data = response.data.data;
    //         this.items = data.data.items;
    //         this.pagination = data.data;
    //         this.page = this.pagination.current_page;
    //         this.totalRecords = this.pagination.total;

    //         if (this.pagination.current_page > this.pagination.last_page) {
    //           this.page = 1;
    //           this.getList(this.page, isSort);
    //         }

    //         this.$router.push({
    //           query: Object.assign({}, this.$route.query, { page: this.page }),
    //         });

    //         const totalColumn = this.headersData.length;
    //         this.columnSearch = [""];

    //         for (let i = 0; i < totalColumn; i++) {
    //           this.columnSearch.push("");
    //         }

    //         this.isLoadDone = true;
    //       } else {
    //         this.snackbar = "danger";
    //         this.message = response.data.result.message;
    //         this.setTimeOutNotification();
    //       }
    //       this.hideLoader();
    //     },
    //     (error) => {
    //       this.snackbar = "danger";
    //       this.message = error;
    //       this.hideLoader();
    //       this.setTimeOutNotification();
    //     }
    //   );
    // },

    changeCheckbox(columnShowed) {
      this.isLoadDone = false;
      this.isLoadDoneDataTable = false;

      this.columnShowed = columnShowed;

      setTimeout(() => {
        this.isLoadDone = true;
        this.checkColumnSearch();
        this.hideLoader();
      }, 100);
    },

    openAddItemModal() {
      this.keyReloadAddItem = Math.random().toString();
      this.isEditItem = 0;
      $("#show-modal-add-item").click();
    },

    showLoader() {
      this.loaderActive = true;
    },

    hideLoader() {
      this.loaderActive = false;
    },

    setLimitPerPage() {
      // Reset to page 1 when changing limit
      this.page = 1;
      this.getList(1, this.type);
    },

    searchKeyword() {
      this.keyword = this.keyword.trim();
      if (this.keyword !== "") {
        this.getList(this.page, this.type);
      } else {
        this.getList(this.page, this.type);
      }
    },
  },
  watch: {
    isLoadDone(val) {
      if (val) {
        setTimeout(() => {
          this.initializeDataTable();
          this.isLoadDoneDataTable = true;
        }, 100);
      }
    },
  },
  mounted() {
    this.getList(this.page);
  },
};
</script>
<style scoped>
table thead th:not(:first-child) {
  padding-left: 10px !important;
  padding-right: 10px !important;
}

table thead th > span {
  position: relative;
}

input[type="search"] {
  border: none;
  background: transparent;
  margin: 0;
  padding: 7px 8px;
  font-size: 14px;
  color: inherit;
  border: 1px solid transparent;
  border-radius: inherit;
}

input[type="search"]::placeholder {
  color: #bbb;
  text-align: left;
  font-weight: normal;
}

input[type="search"]:focus {
  border-color: #72959d;
  outline: none;
  border: none;
  border-bottom: 2px solid #72959d;
}

.nosubmit-parent {
  border: none;
  padding: 0;
}

input.nosubmit {
  border-bottom: 1px solid #d2d2d2;
  width: 100%;
  padding: 9px 4px 9px 40px;
  background: transparent
    url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' class='bi bi-search' viewBox='0 0 16 16'%3E%3Cpath d='M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z'%3E%3C/path%3E%3C/svg%3E")
    no-repeat 13px center;
}

.date-time-dashboad .dp__input_wrap {
  min-width: 200px !important;
  width: 250px;
}

.custom-control-label label {
  padding-top: 14px !important;
}

.pt-custtom {
  padding-top: 7px;
}

tbody:not(.no-data) > tr:nth-child(2n + 1) {
  background: #f0f2f5;
}

tbody:not(.no-data) > tr:hover {
  background: #ebecee;
}

.custom-table :not(caption) > * > * {
  border-right-width: 1px !important;
}

.custom-table :not(caption) > * > *:first-child {
  border-left-width: 1px !important;
}

.dropdownMenuButton {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 15px;
  height: 30px;
}

.dropdown-item {
  display: flex;
  align-items: center;
}

.sample-file {
  cursor: pointer;
  text-decoration: underline;
  color: #133067 !important;
}
table.dataTable .wrapper-sortby::before {
  right: -5px;
}
table.dataTable .wrapper-sortby::after {
  right: -5px;
}

.dt-layout-cell {
  min-height: 250px !important;
}
.dt-layout-table {
  min-height: 250px !important;
}

:deep(.custom-table > .dt-container > .dt-layout-row > .dt-layout-cell > .dt-search) {
  display: none !important;
}

.search-container {
  display: flex;
  align-items: center;
  gap: 5px;
  margin-bottom: 10px;
  width: 50%;
}

.search-container .nosubmit {
  flex: 1;
  margin-right: 0;
}

.search-container .search-btn {
  white-space: nowrap;
  flex-shrink: 0;
  margin-bottom: 0 !important;
}

@media screen and (max-width: 768px) {
  .search-container {
    width: 100%;
  }
}
</style>
